import { render, staticRenderFns } from "./resumenOT.vue?vue&type=template&id=cd30b4e8"
import script from "./resumenOT.vue?vue&type=script&lang=js"
export * from "./resumenOT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports